var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:[
				'alert',
	      _vm.type ? `alert-${_vm.type}` : ''
	    ]},[_c('div',{staticClass:"alert-inner"},[_c('div',{staticClass:"alert-icon"},[_c('span',{staticClass:"icon icon-alert-circle"})]),_vm._v(" "),_c('div',{staticClass:"alert-text"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.closable)?_c('div',{staticClass:"alert-close",on:{"click":_vm.handleClose}},[_c('span',{staticClass:"icon icon-x"})]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }